import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { ApiKeyCreateForm } from "./components/ApiKeyCreateForm";

export function NewApiKeyPage() {
  return (
    <LqsPage title="New API Key">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ApiKeyCreateForm />
      </Container>
    </LqsPage>
  );
}
